import { render, staticRenderFns } from "./SalesByClassFlight.vue?vue&type=template&id=754ff74b&"
import script from "./SalesByClassFlight.vue?vue&type=script&lang=js&"
export * from "./SalesByClassFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports